var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { keysToSnake } from 'utils/converter';
var isUser = function (data) { return typeof data === 'object' && data !== null && 'iss' in data && 'status' in data; };
export default isUser;
export var isUserFile = function (data) { return typeof data === 'object'
    && data !== null
    && 'id' in data
    && 'issUser' in data
    && 'type' in data
    && 'name' in data
    && 'path' in data; };
export var isUserFiles = function (data) { return Array.isArray(data)
    && data.every(isUserFile); };
export var formatPersonalDetailsForBackend = function (user) {
    var _a = keysToSnake(user), birthday = _a.birthday, snakeUser = __rest(_a, ["birthday"]);
    return (__assign(__assign({}, snakeUser), { birthday: new Date(Date.UTC(birthday.year, birthday.month - 1, birthday.day)).toISOString().replace('T', ' ').split('.')[0] }));
};
export var formatPersonalResidenceForBackend = function (user) {
    var _a = keysToSnake(user), usResident = _a.us_resident, snakeUser = __rest(_a, ["us_resident"]);
    return (__assign(__assign({}, snakeUser), { us_resident: usResident === '1' }));
};
export var isUserAnswers = function (data) { return typeof data === 'object' && data !== null && 'issUser' in data && 'appropriatenessScore' in data && 'score' in data; };
